module.exports = __webpack_public_path__ + "img/icon1.c8266dcc.png";